export default class MerchantAccountGroup {
  /**
   * Create new merchant account group and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }
}
